module.exports = __webpack_public_path__ + "img/pink.23b59150.png";